import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentProductos,environmentEmpleados } from '@environments/environment';
import { Observable } from 'rxjs';
import { Application } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class ApplicationService {
    constructor(private http: HttpClient) { }

    getApplicationUserID(idUser) {
        let json = {
            userID: idUser
        }
        return this.http.post<any>(`${environmentProductos.apiUrl}/Application/GetByFilter`,json);
    }

    insertApplication(application: Application) {
        console.log(`${environmentProductos.apiUrl}/Application/InsertOrUpdate`,application)
        return this.http.post<any>(`${environmentProductos.apiUrl}/Application/InsertOrUpdate`,application );
    }

    getHistoryFormularios(page) {
        let json ={
            page : page
        }
        console.log(`${environmentEmpleados.apiUrl}/Application/FindByCurrentUserPaginate`,json)
        return this.http.post<any>(`${environmentEmpleados.apiUrl}/Application/FindByCurrentUserPaginate`,json );
    }



   
}